// extracted by mini-css-extract-plugin
module.exports = {"grid":"ProfileNfts_grid__2z9t0"};